import React, { useState, useEffect } from 'react';
import {
  Box,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Tag,
  VStack,
  Heading,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Image,
  Divider,
} from '@chakra-ui/react';
import axios from 'axios';
import { ChakraProvider } from '@chakra-ui/react';

const CertificateManualVerification = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [data, setData] = useState([]);
  const [selectedCertificate, setSelectedCertificate] = useState(null);
  const { isOpen, onOpen, onClose } = useDisclosure();

  useEffect(() => {
    fetchCertificates();
  }, []);

  const fetchCertificates = async () => {
    const ticketToken = sessionStorage.getItem('ticketToken');
    try {
      const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/admin/get-details-for-manual-verification`,{
        headers: {
            Authorization: `Bearer ${ticketToken}`
        }
      });
      setData(response.data.data);
      console.log("data", response.data.data);
    } catch (error) {
      console.error('Error fetching certificates:', error);
    }
  };

  const handleRowClick = (certificate) => {
    setSelectedCertificate(certificate);
    onOpen();
  };

  const handleApprove = async () => {
    const ticketToken = sessionStorage.getItem('ticketToken');
    try {
      await axios.post(`${process.env.REACT_APP_SERVER_URL}/admin/approve-certificate-verification`, {
        userId: selectedCertificate.userId,
        certificateSpecializationRelationId: selectedCertificate.certificateSpecializationRelationId
      },{
        headers: {
            Authorization: `Bearer ${ticketToken}`
        }
      });
      fetchCertificates(); // Refresh the data
      onClose();
    } catch (error) {
      console.error('Error approving certificate:', error);
    }
  };

  const handleDecline = async () => {
    const ticketToken = sessionStorage.getItem('ticketToken');
    try {
      await axios.post(`${process.env.REACT_APP_SERVER_URL}/admin/decline-certificate-verification`, {
        userId: selectedCertificate.userId,
        certificateSpecializationRelationId: selectedCertificate.certificateSpecializationRelationId
      },{
        headers: {
            Authorization: `Bearer ${ticketToken}`
        }
      });
      fetchCertificates(); // Refresh the data
      onClose();
    } catch (error) {
      console.error('Error declining certificate:', error);
    }
  };

  const filteredData = data.filter(item =>
    item.FullName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <ChakraProvider>
      <Box p={4}>
        <Flex justifyContent="space-between" alignItems="center" mb={4}>
          <Heading>Certificate Manual Verification</Heading>
          <Input
            placeholder="Search by Name..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            width="300px"
          />
        </Flex>

        <Table variant="simple" bg="white" boxShadow="md" borderRadius="md">
          <Thead bg="teal.500">
            <Tr>
              <Th color="white">User Name</Th>
              <Th color="white">Certificate Name</Th>
              <Th color="white">Status</Th>
            </Tr>
          </Thead>
          <Tbody>
            {filteredData.map((item, index) => (
              <Tr key={index} onClick={() => handleRowClick(item)} cursor="pointer" _hover={{ bg: 'teal.50' }}>
                <Td>
                  <Tag colorScheme="teal">{item.FullName}</Tag>
                </Td>
                <Td>{item.certificate}</Td>
                <Td>
                  <Tag colorScheme={item.status === 'not_reviewed' ? 'yellow' : 'green'}>
                    {item.status}
                  </Tag>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>

        <Modal isOpen={isOpen} onClose={onClose} size="lg">
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Certificate Details</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              {selectedCertificate && (
                <VStack spacing={4} align="stretch">
                  <FormControl>
                    <FormLabel>Profile Image</FormLabel>
                    <Image 
                      src={selectedCertificate.profile_image_url} 
                      alt="Profile" 
                      boxSize="80px"
                      borderRadius="full"
                      objectFit="cover"
                      className={selectedCertificate.profile_image_style}
                    />
                  </FormControl>
                  <Divider />
                  <FormControl>
                    <FormLabel>Full Name</FormLabel>
                    <Input value={selectedCertificate.FullName} isReadOnly />
                  </FormControl>
                  <FormControl>
                    <FormLabel>Certificate Name</FormLabel>
                    <Input value={selectedCertificate.certificate} isReadOnly />
                  </FormControl>
                  <FormControl>
                    <FormLabel>Issuing Authority</FormLabel>
                    <Input value={selectedCertificate.issuingAuthority} isReadOnly />
                  </FormControl>
                  <FormControl>
                    <FormLabel>Validity Period</FormLabel>
                    <Input value={selectedCertificate.validityPeriod} isReadOnly />
                  </FormControl>
                  {selectedCertificate.fileUrl && (
                    <FormControl>
                      <FormLabel>Certificate Image</FormLabel>
                      <Image src={selectedCertificate.fileUrl} alt="Certificate" borderRadius="md" />
                    </FormControl>
                  )}
                  <FormControl>
                    <FormLabel>Specializations</FormLabel>
                    <Input value={selectedCertificate.specializations.join(', ')} isReadOnly />
                  </FormControl>
                  <FormControl>
                    <FormLabel>Address</FormLabel>
                    <Input value={selectedCertificate.address.contact_address} isReadOnly />
                  </FormControl>
                </VStack>
              )}
            </ModalBody>
            <ModalFooter>
              <Button colorScheme="green" mr={3} onClick={handleApprove}>
                Approve
              </Button>
              <Button colorScheme="red" mr={3} onClick={handleDecline}>
                Decline
              </Button>
              <Button variant="ghost" onClick={onClose}>
                Close
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </Box>
    </ChakraProvider>
  );
};

export default CertificateManualVerification;